import { MultiStateCheckbox } from 'primereact/multistatecheckbox'
import { useState } from 'react';

export function AccessibilityPropertyCheckbox({id, value, propertyName, onDone}) {
    const [val, setVal] = useState(value);
    const options= [
          {value: 1, icon: 'fa-brands fa-accessible-icon', label: 'Dostępny dla osób na wózkach'},
          {value: 2, icon: 'fa-solid fa-ban', label: 'Niedostępny dla osób na wózkach'}
      ];
  
    function findLabelbyValue(options,val) {
      let found = options.find((element) => (element.value === val));
        if(typeof found === "undefined") {
          return 'Informacja o dostępności dla wózków';
        } else {
          return found['label'];
        }
    }
  
    return (
      <>
        <MultiStateCheckbox 
          value={val}
          options={options}
          onChange={(e) => {
            setVal(e.value);
            onDone(propertyName,e.value);
            }
          }
          optionValue="value"
          optionLabel="label"
          className="mr-2"
          pt={{
            checkbox: {
              id: id + '-' + propertyName
            }
          }}
        />
        <label htmlFor={id + '-' + propertyName}>{ findLabelbyValue(options,val) }</label>
      </>
    )
  }